__turbopack_context__.v({
  "apply": "widget-workbench-module__zmr2Wa__apply",
  "archiveNote": "widget-workbench-module__zmr2Wa__archiveNote",
  "barTrack": "widget-workbench-module__zmr2Wa__barTrack",
  "barValue": "widget-workbench-module__zmr2Wa__barValue",
  "barZero": "widget-workbench-module__zmr2Wa__barZero",
  "bars": "widget-workbench-module__zmr2Wa__bars",
  "checked": "widget-workbench-module__zmr2Wa__checked",
  "checks": "widget-workbench-module__zmr2Wa__checks",
  "codeEditor": "widget-workbench-module__zmr2Wa__codeEditor",
  "description": "widget-workbench-module__zmr2Wa__description",
  "disclosure": "widget-workbench-module__zmr2Wa__disclosure",
  "draftNote": "widget-workbench-module__zmr2Wa__draftNote",
  "editor": "widget-workbench-module__zmr2Wa__editor",
  "editorRow": "widget-workbench-module__zmr2Wa__editorRow",
  "empty": "widget-workbench-module__zmr2Wa__empty",
  "emptyDiagram": "widget-workbench-module__zmr2Wa__emptyDiagram",
  "error": "widget-workbench-module__zmr2Wa__error",
  "exportActions": "widget-workbench-module__zmr2Wa__exportActions",
  "field": "widget-workbench-module__zmr2Wa__field",
  "fieldActions": "widget-workbench-module__zmr2Wa__fieldActions",
  "fieldConflict": "widget-workbench-module__zmr2Wa__fieldConflict",
  "filterEmpty": "widget-workbench-module__zmr2Wa__filterEmpty",
  "group": "widget-workbench-module__zmr2Wa__group",
  "groupBody": "widget-workbench-module__zmr2Wa__groupBody",
  "hiddenDrafts": "widget-workbench-module__zmr2Wa__hiddenDrafts",
  "historyNote": "widget-workbench-module__zmr2Wa__historyNote",
  "instrument": "widget-workbench-module__zmr2Wa__instrument",
  "instrumentTop": "widget-workbench-module__zmr2Wa__instrumentTop",
  "library": "widget-workbench-module__zmr2Wa__library",
  "libraryHeader": "widget-workbench-module__zmr2Wa__libraryHeader",
  "libraryMark": "widget-workbench-module__zmr2Wa__libraryMark",
  "line": "widget-workbench-module__zmr2Wa__line",
  "loading": "widget-workbench-module__zmr2Wa__loading",
  "metric": "widget-workbench-module__zmr2Wa__metric",
  "nodeHeading": "widget-workbench-module__zmr2Wa__nodeHeading",
  "nodeText": "widget-workbench-module__zmr2Wa__nodeText",
  "notice": "widget-workbench-module__zmr2Wa__notice",
  "overline": "widget-workbench-module__zmr2Wa__overline",
  "primary": "widget-workbench-module__zmr2Wa__primary",
  "progress": "widget-workbench-module__zmr2Wa__progress",
  "provenance": "widget-workbench-module__zmr2Wa__provenance",
  "quiet": "widget-workbench-module__zmr2Wa__quiet",
  "restoreConfirm": "widget-workbench-module__zmr2Wa__restoreConfirm",
  "secondary": "widget-workbench-module__zmr2Wa__secondary",
  "slider": "widget-workbench-module__zmr2Wa__slider",
  "source": "widget-workbench-module__zmr2Wa__source",
  "surface": "widget-workbench-module__zmr2Wa__surface",
  "sync": "widget-workbench-module__zmr2Wa__sync",
  "tableScroll": "widget-workbench-module__zmr2Wa__tableScroll",
  "textButton": "widget-workbench-module__zmr2Wa__textButton",
  "titleRow": "widget-workbench-module__zmr2Wa__titleRow",
  "toggle": "widget-workbench-module__zmr2Wa__toggle",
  "toolbar": "widget-workbench-module__zmr2Wa__toolbar",
  "versionHeading": "widget-workbench-module__zmr2Wa__versionHeading",
  "versions": "widget-workbench-module__zmr2Wa__versions",
  "workbench": "widget-workbench-module__zmr2Wa__workbench",
});
